enum ChartColors {
  PRIMARY = "#6B87FF",
  SECONDARY = "rgba(102, 236, 165, 0.7)",
  BG_PRIMARY = "#BFD5FF",
  BG_SECONDARY = "rgba(102, 236, 165, 0.7)",
  PRIMARY_RGBA = "rgba(191, 213, 255, 0.7)",
  //
  OK = "#7CE299",
  OFF = "rgba(244,67,54,1)",
  LOW = "#FDDA86",
  BAD = "#DB9F7D",
  PAUSED = "#B7BFC8",
  STOPPED = "#000",
  STARTING = "#39A0FF",
  CONNECTION_ERROR = "#9D3630",

  GRAY = "#A0B0C7",
}

export default ChartColors;
